import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ai9roe1n9e: FaireBrandEntity = {
  token: "b_ai9roe1n9e",
  type: "brand",
  name: "Vitanica",
  avatarUrl:
    "https://cdn.faire.com/fastly/c8049d58c600b7544140bda82f8f4331b0d4c85fc2d4b9454a73b00c50ec775a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/53405963853690ad91b56c7107d611499b7e77430f174522bf621f6cf0880426.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c8049d58c600b7544140bda82f8f4331b0d4c85fc2d4b9454a73b00c50ec775a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/53405963853690ad91b56c7107d611499b7e77430f174522bf621f6cf0880426.jpeg",
  location: "Tualatin, OR, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 15,
  isInsider: true,
  description:
    "Over 29 years ago, Dr. Tori Hudson created Vitanica, to serve women. Dr. Hudson is a nationally recognized author, speaker, educator, researcher, clinician and the first woman in the United States to become a full professor of Naturopathic Medicine. Dr. Hudson has specialized in women’s health for over 37 years. \n\nVitanica is committed to maintaining the purity and effectiveness of our dietary supplements. We believe this is accomplished by focusing on the principles that contribute to well designed products which will support health without contributing to toxicity, utilizing safe and effective ingredients.\n\nWe seek excellence in our formulations by including optimal dosages, superior choice nutrient sources and clinically scrutinized products for maximal therapeutic benefit. We are committed to using the highest quality, premium grade organic or wildcrafted herbs available. Our herbs and extracts are selected on the basis of purity, bioactivity, and maximal therapeutic benefit. Raw materials and finished products undergo rigorous testing for identity, purity, and quality. Our entire product line is gluten-free, non-GMO and vegetarian suitable, including the use of plant based capsules.\n\nOur dietary supplement manufacturing facilities are third-party certified and meet all Good Manufacturing Practice standards set forth by the FDA Dietary Supplement Health and Education Act.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:16.515Z",
    importedBy: "entity-db-cli",
  },
};
